import { LoginDataProps } from "Types/LoginDataProps";

export const DefaultLoginStruct: LoginDataProps = {
  username                    : "",
  status                      : "",
  profilePhoto                : "",
  city                        : "",
  country                     : "",
  lastLoginDate               : "",
  tokenHash                   : "",

  firstLogin                  : false,
  forceApprovePrivacyPolicy   : false,
  isEmailVerified             : false,
  isKycVerified               : false,
  isSmsVerified               : false,
  kycEnabled                  : false,

  balance : {
    activeBalance             : "",
    casinoBonusBalance        : "",
    currencyCode              : "",
    freeBalance               : "",
    reservedWithdrawBalance   : "",
    sportBonusBalance         : "",
    totalBalance              : "",
    totalBonusBalance         : ""
  }
};